module.exports = __webpack_public_path__ + "img/二维码.d176580c.png";